var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c(_vm.layoutComponent,{tag:"component"},[(_vm.routeAllowed)?_c('router-view',{key:_vm.viewKey}):(_vm.routePending)?_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(true),expression:"true"}],staticClass:"route-pending",attrs:{"data-testid":"route-pending"}}):_vm._e()],1),_c('LoadingProgress')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }